import axios from 'axios'
import {API_BASE_URL, Env} from '../constants/appConstant'
import * as AppUrl from '../constants/appUrl'
import history from '../routes/history'
import auth from './auth'
import alertMessage from './alertMessage'

axios.defaults.withCredentials = false

const instance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 1000 * 60 * 3,

  headers: {
    'Content-Type': 'application/json',
  },
})

instance.interceptors.request.use(
  config => {
    const authInfo = auth.getAuthInfo()

    if (!!authInfo.token) {
      config.headers.Authorization = `Bearer ${authInfo.token}`
      // config.headers['PSP-Authorization'] = `${authInfo.pspToken}`;
      config.headers['Auth-Type'] = 'ssofed'
      //config.headers["Ocp-Apim-Subscription-Key"]= `${window.g.SUBSCRIPTION_KEY_LOGIN}`
    }

    return config
  },
  error => Promise.reject(error)
)
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // auth.logout();
          history.push({pathname: AppUrl.LOGIN})
          break
        case 403:
          // mAlert.error('无权访问');
          // history.push({ pathname: AppUrl.APPLYPERMISSIN })
          break
        case 404:
          console.log('资源未找到')
          //mAlert.error('资源未找到');
          break
        case 500:
          alertMessage.error(error.response.data.error)
          break
        case 502:
          console.log('网关错误')
          //mAlert.error('网关错误');
          break
        case 504:
          console.log('网关请求超时')
          //mAlert.error('网关请求超时');
          break
        default:

          break
      }
    }
    return Promise.reject(error)
  }
)

// function decorateResponseData(res) {
//   try {
//     if (res.data.hasOwnProperty('data') && res.data.hasOwnProperty('code') && res.data.hasOwnProperty('message')) {
//       return {
//         message: res.data['message'],
//         code: res.data['code'],
//         data: res.data['data'],
//       }
//     }
//     return {
//       message: '',
//       code: 0,
//       data: res.data,
//     }
//   } catch (err) {
//     return {
//       message: '',
//       code: 0,
//       data: res.data,
//     }
//   }
// }

function decorateRequestData(data) {
  // const authInfo = auth.getAuthInfo();
  // const userId = authInfo.userCode;

  return {
    // transaction: {
    //   userId,
    // },
    //token:authInfo.token,
    data,
  }
}

function get(url, data, config = {}) {
  // const authInfo = auth.getAuthInfo();
  let params = ''
  if (!!data) {
    for (let key in data) {
      if (!!data[key]) {
        params += `&${key}=${data[key]}`
      }
    }
  }
  if (url.indexOf('?') !== -1) {
    url += params
  } else {
    url += `?${params.slice(1, params.length)}`
  }
  return new Promise((resolve, reject) => {
    instance
      .get(url, {
        params: {
          //_t: Date.now(),
          //token:authInfo.token,
        },
        ...config,
      })
      .then(res => {
        const response = res
        // if (response.status === 200) {
        //   resolve(response)
        // } else {
        //   reject(response)
        // }
        if (response.status === 200) {
          if (response.data.code === 0 || response.data.code === 403 || response.data.code === 401) {
            resolve(response)
          } else if (response.data.code !== 0 && response.data.code !== 100) {
            console.log(`Error Url: ${response.config.url} Error Message: ${response.data.message}`)
            alertMessage.error(response.data.message)
            reject(response.data)
          } else if (response.data.code === 100) {
            alertMessage.warning(response.data.message)
            if (Env === 'local') {
              history.push({pathname: AppUrl.LOGIN})
            } else {
              window.location.href = `${window.g.ssoLoginUrl}`
            }
          }
        } else {
          reject(response.data)
          alertMessage.error('Failed! System error, please contact the administrator.')
        }
      })
      .catch(error => {
        const errMsg = error.response ? error.response.data.message : error.message
        reject(errMsg)
      })
  })
}

function post(url, data, config = {}) {
  return new Promise((resolve, reject) => {
    instance
      //.post(url, JSON.stringify(decorateRequestData(data)))
      .post(url, JSON.stringify(data), config)
      .then(res => {
        //const response = decorateResponseData(res);
        const response = res
        if (response.status === 200) {
          if (response.data.code === 0 || response.data.code === 403 || response.data.code === 401) {
            resolve(response)
          } else if (response.data.code !== 0 && response.data.code !== 100) {
            console.log(`Error Url: ${response.config.url} Error Message: ${response.data.message}`)
            alertMessage.error(response.data.message)
            reject(response.data)
          } else if (response.data.code === 100) {
            alertMessage.warning(response.data.message)
            if (Env === 'local') {
              history.push({pathname: AppUrl.LOGIN})
            } else {
              window.location.href = `${window.g.ssoLoginUrl}`
            }
          }
        } else {
          reject(response.data)
          alertMessage.error('Failed! System error, please contact the administrator.')
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

function postFormData(url, data, config = {}) {
  return new Promise((resolve, reject) => {
    const formData = new FormData()
    Object.keys(data).forEach(key => formData.append('files', data[key].originFileObj))
    instance
      .post(url, formData || {}, config)
      .then(res => {
        const response = res
        if (response.data.code === 0) {
          resolve(response)
        } else {
          console.log('response', response)
          reject(response)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

function del(url, data) {
  return new Promise((resolve, reject) => {
    instance
      .delete(url, {data: decorateRequestData(data)})
      .then(res => {
        const response = res
        if (response.status === 200) {
          resolve(response)
        } else {
          reject(response)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const http = {
  get,
  post,
  postFormData,
  delete: del,
}
